export enum NameDisplay {
    SHOW_ALL = 0,
    SHOW_EDITION_ONLY = 1,
    SHOW_YEAR_ONLY = 2,
    SHOW_NONE = 9
}

export enum EditionDisplay {
    ARABIC = 0,
    ORDINAL = 1,
    ROMAN = 2,
}